export const createMeshesArrayBasedAnother = ({ basedMeshesArray, outputLength, withRandom = false }) => {
    const result = Array.from({ length: outputLength }, (_, i) => {
        const index = i % basedMeshesArray.length;
        return basedMeshesArray[index]?.clone();
    });
    return withRandom ? result.sort(() => Math.random() - 0.5) : result;
};
